import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const SpecificContractMessage = styled.div`
    display: flex; 
    flex-direction: column;

    gap: 25px;

    ul {
        padding: 0;
        list-style: none;

        li {

        }
    }
`;

export const Container = styled.div`
    p {
        color: ${(props) => props.theme.grey};
        font-size: ${theme.font.size16};
    }

    h1 {
        color: ${(props) => props.theme.black};
        font-size: ${theme.font.size24};
        font-weight: bold;
    }
`;

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const LinkButton = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: -16px;

    span {
        font-size: ${theme.font.size16};
        font-weight: bold;
        text-decoration: underline;
        color: ${(props) => props.theme.lightGrey};
        cursor: not-allowed;

        &.active {
            color: ${(props) => props.theme.orangeLink};
            cursor: pointer;
        }
    }
`;
